import ContinueShopping from './lib/ContinueShopping';

export default ContinueShopping;
